/* eslint-disable unicorn/prefer-module */
/* eslint-disable max-len */
/* eslint-disable prettier/prettier */
/* eslint-disable no-console */
import { useState } from "react";
import toast from "react-hot-toast";
import { getContratos, log, registrarCredito, tieneEdificiosAsignados, updateContrato, updateOportunidad, updateOportunidadBTL } from "../../../utils";
import { invalidarPctCongelado } from "../../../utils/comisionSnapshot";
import { congelarPctIntermediacion } from "../../../utils/congelarPctIntermediacion";
import { client } from "../../../utils/supabase";

export const useVFEditModal = ({ todasOportunidades, setTodasOportunidades, pais, getUFValue, userId, siiMap }) => {
  const [showModal, setShowModal] = useState(false);
  const [oportunidadEditada, setOportunidadEditada] = useState(null);
  const [formData, setFormData] = useState({
    facturanumero: "",
    facturafecha: "",
    plazocobro: "",
    facturafechacobro: "",
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [registrarComoCredito, setRegistrarComoCredito] = useState(false);
  const [facturaSIIVinculada, setFacturaSIIVinculada] = useState(null);

  const handleOpenModal = async (oportunidad) => {
    setOportunidadEditada(oportunidad);
    setFormData({
      facturanumero: oportunidad.facturanumero || "",
      facturafecha: oportunidad.facturafecha
        ? new Date(oportunidad.facturafecha).toISOString().split("T")[0]
        : "",
      plazocobro: oportunidad.plazocobro
        ? new Date(oportunidad.plazocobro).toISOString().split("T")[0]
        : "",
      facturafechacobro: oportunidad.facturafechacobro
        ? new Date(oportunidad.facturafechacobro).toISOString().split("T")[0]
        : "",
    });
    setShowModal(true);
    setError(null);
    // Buscar factura SII vinculada
    try {
      const { data } = await client
        .from("facturas_sii_emitidas")
        .select("id, folio, monto_total, facturafechacobro, razon_social_receptor")
        .eq("venta_tipo", "sales")
        .eq("venta_ref_id", oportunidad.id)
        .eq("estado_vinculacion", "vinculada")
        .maybeSingle();
      setFacturaSIIVinculada(data || null);
    } catch {
      setFacturaSIIVinculada(null);
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setOportunidadEditada(null);
    setFormData({ facturanumero: "", facturafecha: "", facturafechacobro: "" });
    setError(null);
    setLoading(false);
    setRegistrarComoCredito(false);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSaveChanges = async () => {
    if (!oportunidadEditada) return;

    // Validaciones
    if (!formData.facturanumero.trim()) {
      setError("El número de factura es obligatorio");
      return;
    }
    if (!formData.facturafecha) {
      setError("La fecha de factura es obligatoria");
      return;
    }

    // Validar que plazocobro >= facturafecha
    if (formData.plazocobro && formData.plazocobro < formData.facturafecha) {
      setError("La fecha proyectada no puede ser anterior a la fecha de factura");
      return;
    }

    // Guard duro: no se puede facturar una venta/cuota sin edificios asignados.
    // Aplica a sales lineal (edificiosparticipantes) y a cada cuota de sales_contratos
    // (meses[].edificios_ids). Corre ANTES de cualquier write a DB; si bloquea, el modal
    // queda abierto con los datos cargados. Predicado compartido (tieneEdificiosAsignados):
    // misma definición que el guard del lado SII en vincularFacturaEmitida.
    if (oportunidadEditada.type === "contrato" && !tieneEdificiosAsignados(oportunidadEditada.edificios_ids)) {
      toast.error(
        `No se puede facturar: la cuota de ${oportunidadEditada.mes}/${oportunidadEditada.ano} no tiene edificios asignados. Asigná los edificios del mes antes de facturar.`
      );
      return;
    }
    if (oportunidadEditada.type === "pauta" && !tieneEdificiosAsignados(oportunidadEditada.edificiosparticipantes)) {
      toast.error(
        "No se puede facturar: la venta no tiene edificios asignados. Asigná los edificios antes de facturar."
      );
      return;
    }

    // Nota: un mismo número de factura puede estar asociado a múltiples servicios/edificios
    // (ej: gestión PSd I y PSd II en una misma factura, o OPEX + gestión de un edificio)

    try {
      setLoading(true);

      const updatedOportunidad = {
        facturafecha: formData.facturafecha, // "2025-12-10"
        plazocobro: formData.plazocobro || null,
        facturanumero: formData.facturanumero,
        updated_at: new Date().toISOString(),
      };

      if (oportunidadEditada.type === "contrato") {
        // Contratos: actualizar el mes específico dentro del JSONB meses
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidadEditada.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidadEditada.mes_index] = {
          ...updatedMeses[oportunidadEditada.mes_index],
          facturafecha: updatedOportunidad.facturafecha,
          facturanumero: updatedOportunidad.facturanumero,
          plazocobro: updatedOportunidad.plazocobro,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
        // A2b (7.22): congelar el % del mes en la transición manual a facturada. Aditivo, no aborta.
        if (updatedOportunidad.facturafecha) {
          await congelarPctIntermediacion({
            origenTipo: "contrato_mes",
            contratoId: contrato.id,
            mes: updatedMeses[oportunidadEditada.mes_index]?.mes,
            facturaDate: updatedOportunidad.facturafecha,
          });
        }
      } else if (oportunidadEditada.type === "HW-CAPEX") {
        // L6 tramo 2: por RPC, sin dereferenciar el array por posición. El tramo hardware ya existe (su
        // alta la hace FacturacionHardwareModal); acá solo se editan sus campos de facturación por linea_id.
        const lineaId = oportunidadEditada.linea_id ?? null;
        if (lineaId == null) {
          throw new Error(
            "No se encontró la línea de facturación del tramo de hardware. Reintentá; si persiste, avisá."
          );
        }
        const { error: rpcErr } = await client.rpc("actualizar_linea_facturacion", {
          p_linea_id: lineaId,
          p_campos: {
            facturanumero: updatedOportunidad.facturanumero,
            facturafecha: updatedOportunidad.facturafecha,
            plazocobro: updatedOportunidad.plazocobro,
          },
          p_usuario_id: parseInt(userId, 10) || null,
        });
        if (rpcErr) throw rpcErr;
      } else if (oportunidadEditada.type === "HW-OPEX" || oportunidadEditada.type === "Gestión") {
        // L6 tramo 2: gestión/opex por upsert_linea_facturacion (crea o edita por CLAVE NATURAL —
        // única forma de crear una línea, 10.1). Sin leer/escribir el array por índice.
        const tipoFact = oportunidadEditada.type === "HW-OPEX" ? "opex" : "gestion";
        const { error: rpcErr } = await client.rpc("upsert_linea_facturacion", {
          p_negocio_id: String(oportunidadEditada.negocio_id),
          p_tipo: tipoFact,
          p_ano: String(oportunidadEditada.ano),
          p_mes: String(oportunidadEditada.mes),
          p_tramo: 1,
          p_campos: {
            facturanumero: updatedOportunidad.facturanumero,
            facturafecha: updatedOportunidad.facturafecha,
            plazocobro: updatedOportunidad.plazocobro,
          },
          p_usuario_id: parseInt(userId, 10) || null,
        });
        if (rpcErr) throw rpcErr;

        // Sincronizar tipo opuesto (opex↔gestion) si no tiene factura. El estado del opuesto se lee de
        // las oportunidades en memoria (mismo negocio/mes/ano), NO del array; al aceptar, upsert (10.1).
        const tipoOpuestoLabel = tipoFact === "opex" ? "Gestión" : "HW-OPEX";
        const tipoOpuestoFact = tipoFact === "opex" ? "gestion" : "opex";
        const entradaOpuesta = todasOportunidades.find(
          (op) =>
            String(op.negocio_id) === String(oportunidadEditada.negocio_id) &&
            op.mes === oportunidadEditada.mes &&
            op.ano === oportunidadEditada.ano &&
            op.type === tipoOpuestoLabel
        );
        if (entradaOpuesta && (!entradaOpuesta.facturanumero || !String(entradaOpuesta.facturanumero).trim())) {
          toast(
            (t) => (
              <div style={{ fontSize: "0.85rem" }}>
                <div style={{ marginBottom: 8 }}>
                  ¿Aplicar factura <strong>{updatedOportunidad.facturanumero}</strong> también a{" "}
                  <strong>{tipoOpuestoLabel}</strong> del mismo mes?
                </div>
                <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                  <button
                    onClick={() => toast.dismiss(t.id)}
                    style={{
                      padding: "4px 12px",
                      fontSize: "0.78rem",
                      border: "1px solid #ccc",
                      borderRadius: 4,
                      background: "#fff",
                      cursor: "pointer",
                    }}
                  >
                    No
                  </button>
                  <button
                    onClick={async () => {
                      toast.dismiss(t.id);
                      try {
                        // Mismo camino de creación/edición que el ancla (10.1): upsert por clave natural.
                        const { error: opErr } = await client.rpc("upsert_linea_facturacion", {
                          p_negocio_id: String(oportunidadEditada.negocio_id),
                          p_tipo: tipoOpuestoFact,
                          p_ano: String(oportunidadEditada.ano),
                          p_mes: String(oportunidadEditada.mes),
                          p_tramo: 1,
                          p_campos: {
                            facturafecha: updatedOportunidad.facturafecha,
                            facturanumero: updatedOportunidad.facturanumero,
                            plazocobro: updatedOportunidad.plazocobro,
                          },
                          p_usuario_id: parseInt(userId, 10) || null,
                        });
                        if (opErr) throw opErr;
                        // Actualizar la fila opuesta en el state local (por ID estable, 10.7)
                        setTodasOportunidades((prev) =>
                          prev.map((op) =>
                            op.id === entradaOpuesta.id
                              ? {
                                  ...op,
                                  facturafecha: updatedOportunidad.facturafecha,
                                  facturanumero: updatedOportunidad.facturanumero,
                                  plazocobro: updatedOportunidad.plazocobro,
                                }
                              : op
                          )
                        );
                        toast.success(`Factura aplicada a ${tipoOpuestoLabel}`);
                      } catch (err) {
                        console.error("Error sincronizando tipo opuesto:", err);
                        toast.error("Error al sincronizar");
                      }
                    }}
                    style={{
                      padding: "4px 12px",
                      fontSize: "0.78rem",
                      border: "none",
                      borderRadius: 4,
                      background: "#2c3e50",
                      color: "#fff",
                      cursor: "pointer",
                      fontWeight: 600,
                    }}
                  >
                    Sí
                  </button>
                </div>
              </div>
            ),
            { duration: 5000 }
          );
        }
      } else if (oportunidadEditada.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
      } else {
        const resUpd = await updateOportunidad({ id: oportunidadEditada.id, oportunidad: updatedOportunidad });
        if (resUpd?.snapshotFallo) {
          toast.error("La venta se guardó, pero la foto de comisión no se pudo actualizar (queda registrado).");
        }
        // A2b (7.22): congelar el % en la transición manual a facturada (pauta). Aditivo, no aborta.
        if (updatedOportunidad.facturafecha) {
          await congelarPctIntermediacion({
            origenTipo: "sale",
            saleId: oportunidadEditada.id,
            facturaDate: updatedOportunidad.facturafecha,
          });
        }
      }

      // Recalcular mes/ano derivados si la fecha de factura cambió
      let derivedFields = {};
      if (updatedOportunidad.facturafecha) {
        const [y, mStr] = updatedOportunidad.facturafecha.split("-");
        derivedFields = { mes: mStr, ano: y };
      }
      setTodasOportunidades((prev) =>
        prev.map((op) => {
          if (op.id !== oportunidadEditada.id) return op;
          const updated = { ...op, ...updatedOportunidad, ...derivedFields };
          // Recalcular importe si la moneda es UF y cambió facturafecha
          if (updatedOportunidad.facturafecha && op.valor_cuota && op.moneda_cuota === "UF") {
            updated.importe = op.valor_cuota * (getUFValue(updatedOportunidad.facturafecha) || 1);
          }
          return updated;
        })
      );

      // Registrar crédito si se marcó la opción (contrato sin edificios)
      if (registrarComoCredito && oportunidadEditada.type === "contrato" && oportunidadEditada.client_id) {
        try {
          await registrarCredito({
            clientId: oportunidadEditada.client_id,
            pais,
            tipo: "carga",
            monto: oportunidadEditada.importe || 0,
            moneda: oportunidadEditada.moneda_dolar ? "USD" : (pais === "Peru" ? "PEN" : "CLP"),
            referenciaId: String(oportunidadEditada.contrato_id),
            referenciaTipo: "sales_contratos",
            descripcion: `Factura ${formData.facturanumero} — crédito anticipado`,
            usuarioId: parseInt(userId, 10),
          });
          toast.success("Crédito registrado para el cliente");
        } catch (creditError) {
          log.error("registrarCredito", creditError);
          toast.error("Factura guardada, pero hubo un error al registrar el crédito");
        }
      }

      toast.success("Factura actualizada correctamente");
      handleCloseModal();
    } catch (error) {
      if (error.code === "23505") {
        setError("El número de factura ya existe");
      } else {
        setError("Hubo un error al actualizar la oportunidad, prueba de nuevo.");
      }
      log.error("handleSaveChanges", error);
    } finally {
      setLoading(false);
    }
  };

  const handleClearFactura = async () => {
    if (!oportunidadEditada) return;

    // Candado L0 anti-corrimiento de índices (plan-lineas-facturacion-maestro-2026-09-19.md): desfacturar
    // Gestión/HW-OPEX hace un `filter` que ELIMINA el elemento de meses_facturacion y corre los índices;
    // si ese elemento tiene una factura vinculada en el puente, el vínculo queda repuntado (enredo De La
    // Industria). Antes de escribir, avisamos claro y mandamos a desvincular primero. Reusa siiMap._byRef
    // (10.1), no consulta la tabla. La garantía dura es el trigger en DB; esto es el aviso previo (10.177).
    const op = oportunidadEditada;
    let refKeyCandado = null;
    if (op.type === "HW-CAPEX") refKeyCandado = `negocios_carteleria_hw:${op.negocio_id}:${op.entry_index ?? ""}`;
    else if (op.type === "HW-OPEX" || op.type === "Gestión")
      refKeyCandado = `negocios_carteleria:${op.negocio_id}:${op.sii_ref_index ?? ""}`;
    if (refKeyCandado && siiMap?._byRef?.[refKeyCandado]) {
      const folioVinc = siiMap._byRef[refKeyCandado].folio;
      setError(
        `No se puede desfacturar: esta línea tiene la factura ${folioVinc} vinculada en ${
          pais === "Chile" ? "SII" : "SUNAT"
        }. Desvinculá la factura primero (columna SII) y volvé a intentar.`
      );
      return;
    }

    try {
      setLoading(true);
      const nullFactura = { facturafecha: null, plazocobro: null, facturanumero: null, updated_at: new Date().toISOString() };

      if (oportunidadEditada.type === "contrato") {
        const contratosRaw = await getContratos({ pais });
        const contrato = contratosRaw.find((c) => c.id === oportunidadEditada.contrato_id);
        if (!contrato) throw new Error("Contrato no encontrado");
        const updatedMeses = [...(contrato.meses || [])];
        updatedMeses[oportunidadEditada.mes_index] = {
          ...updatedMeses[oportunidadEditada.mes_index],
          facturafecha: null, facturanumero: null, plazocobro: null,
        };
        await updateContrato({ id: contrato.id, contrato: { meses: updatedMeses } });
        // A4 (7.22): invalidar la foto del % del mes al desfacturar (no toca meses hermanos).
        await invalidarPctCongelado({
          origenTipo: "contrato_mes",
          contratoId: contrato.id,
          mes: updatedMeses[oportunidadEditada.mes_index]?.mes,
        });
      } else if (
        oportunidadEditada.type === "HW-CAPEX" ||
        oportunidadEditada.type === "HW-OPEX" ||
        oportunidadEditada.type === "Gestión"
      ) {
        // L6 tramo 2: desfacturar por RPC (linea_id), sin tocar el array por posición. Gestión/opex quita
        // el elemento; hardware limpia los campos de facturación del tramo (mismo efecto que hoy). El
        // candado L0 (puente) vive en la RPC; el pre-check por _byRef de arriba es el aviso previo (10.177).
        const lineaId = oportunidadEditada.linea_id ?? null;
        if (lineaId == null) {
          throw new Error(
            "No se encontró la línea de facturación para desfacturar. Reintentá; si persiste, avisá."
          );
        }
        const { error: rpcErr } = await client.rpc("desfacturar_linea_facturacion", {
          p_linea_id: lineaId,
          p_usuario_id: parseInt(userId, 10) || null,
        });
        if (rpcErr) throw rpcErr;
      } else if (oportunidadEditada.type === "BTL") {
        await updateOportunidadBTL({ id: oportunidadEditada.id, oportunidad: nullFactura });
      } else {
        await updateOportunidad({ id: oportunidadEditada.id, oportunidad: nullFactura });
        // A4 (7.22): invalidar la foto del % al desfacturar (pauta).
        await invalidarPctCongelado({ origenTipo: "sale", saleId: oportunidadEditada.id });
      }

      setTodasOportunidades((prev) =>
        prev.map((op) =>
          op.id !== oportunidadEditada.id
            ? op
            : { ...op, facturanumero: null, facturafecha: null, plazocobro: null }
        )
      );
      toast.success("Factura eliminada correctamente");
      handleCloseModal();
    } catch (error) {
      // Candado L0: si la base rechaza igual (el aviso previo por _byRef no cubrió el caso), mostrar el
      // mensaje tal cual (10.177), no el genérico. Cubre el trigger de índices y la RPC desfacturar_linea.
      if (
        typeof error?.message === "string" &&
        (error.message.includes("candado_indices") || error.message.includes("factura vinculada"))
      ) {
        setError(error.message);
      } else {
        setError("Hubo un error al eliminar la factura, prueba de nuevo.");
      }
      log.error("handleClearFactura", error);
    } finally {
      setLoading(false);
    }
  };

  // Otras oportunidades que ya usan el mismo número de factura (info, no bloqueo)
  const otrasConMismaFactura = formData.facturanumero.trim()
    ? todasOportunidades.filter(
      (op) =>
        op.facturanumero === formData.facturanumero.trim() &&
        op.id !== (oportunidadEditada?.id || null)
    )
    : [];

  const warnSinEdificios =
    oportunidadEditada?.type === "contrato" && !oportunidadEditada?.edificios_ids;

  return {
    showModal,
    oportunidadEditada,
    formData,
    loading,
    error,
    warnSinEdificios,
    registrarComoCredito,
    setRegistrarComoCredito,
    otrasConMismaFactura,
    handleOpenModal,
    handleCloseModal,
    handleInputChange,
    handleSaveChanges,
    handleClearFactura,
    facturaSIIVinculada,
  };
};
